const NETWORK_DISCONNECT_PATTERNS = [
  // Chromium (Chrome / Edge / new WebOS / new Tizen / Android WebView)
  "Failed to fetch",
  "ERR_INTERNET_DISCONNECTED",
  "ERR_NETWORK",
  "ERR_NAME_NOT_RESOLVED",
  "ERR_ADDRESS_UNREACHABLE",

  // Firefox
  "NetworkError",

  // WebKit / Safari (older Tizen, iOS, any WebKit-shell)
  "Load failed",
  "The Internet connection appears to be offline",
  "The network connection was lost",
  "A server with the specified hostname could not be found",

  // React Native / some HTTP libs
  "Network request failed",

  // App-specific (custom throw from KeycloakProvider pre-check)
  "No internet connection",
] as const;

const hasStatusCode = (e: unknown): e is { statusCode: number } =>
  typeof e === "object" &&
  e !== null &&
  typeof (e as { statusCode?: unknown }).statusCode === "number";

const isAbortError = (e: unknown): boolean =>
  typeof e === "object" &&
  e !== null &&
  (e as { name?: unknown }).name === "AbortError";

const matchesDisconnectPattern = (e: unknown): boolean => {
  const message =
    typeof e === "object" && e !== null
      ? (e as { message?: unknown }).message
      : undefined;
  if (typeof message !== "string") return false;
  return NETWORK_DISCONNECT_PATTERNS.some((p) => message.includes(p));
};

export const isNetworkDisconnectError = (error: unknown): boolean => {
  if (!error) return false;
  if (hasStatusCode(error)) return false;
  if (isAbortError(error)) return false;
  if (typeof navigator !== "undefined" && navigator.onLine === false) {
    return true;
  }
  return matchesDisconnectPattern(error);
};
